import React, {useEffect, useState} from "react";
import {Row, Col} from "react-flexbox-grid";
import {Modal, Form, Button,Alert} from "react-bootstrap";
import { FinanceStreamChart } from "./Charts/financeStream";
import {MapChart} from "./Charts/mapChart";
import {GenderFinanceChart} from "./Charts/genderFinanceChart";
import {SelectCountyChart} from "./Charts/selectAdminLevel";
import { ValueChainsChart} from "./Charts/valueChains";
import {DealSizeChart} from "./Charts/dealSize";
import {DataCountChart} from "./Charts/dataCountChart";
import {SizeOfRecipientFirms} from "./Charts/sizeOfFirmsChart";
import {AgeOfRecipient} from "./Charts/ageOfRecipient";
import {Desc} from "./Charts/investmentDesc.Chart";
import {DealCatSizeChart} from "./Charts/dealSizeCattwo";
import {DataContext} from "./Charts/cxContext";
import {css} from "glamor";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";

export const Dashboard = (props) => {
    const [show, setShow] = useState(false);
    const [showAlert,SetShowAlert] = useState(false)
    const [checked, setChecked] = useState(false);
    const handleClose = () => {
        setShow(false);
        setClicked(true);
    }
    const [clicked ,setClicked] = useState(false)
    // const handleShow = () => setShow(true);

    // create global variables
    window.ICHECKED = checked
    window.IREQUEST_STATUS = clicked

    const handleClick = () => setChecked(!checked);

    const handleShow = () => {
        if (typeof window.ADMINLEVEL === 'undefined') {
                // alert the user to  make a selection
            window.alert("Select atleast one county")
            
        } else if (typeof window.IVALUECHAINS === 'undefined') {
            window.alert("You need to  select  at least one ValueChain")
        } else if (typeof window.IFINANCESTREAM === 'undefined'){
         window.alert("You need to  select Finance Stream")
        } else {
            setShow(true)
        }
        
        //else if (typeof window.valueChains === 'undefined') {
        // window.alert("You need to  select  at least one Value Chain")
        // }else{

        // }

    };

    const style = css({padding: "0.2rem", marginTop: "1.5rem", fontSize: "0.9rem"});
    const chart_widget_style = css({background: "aliceblue", border: "3px solid white"});
    const text_widgets = css({display: "inline-flex", marginBottom: "3px", border: "0.2px solid #eaeaea", color: "#01528c"});
    const text_widgets_vlaue = css({
        width: "11.7rem",
        textAlign: "center",
        margin: "auto",
        coloe: "#01528c",
        "& strong": {}
    });
    const primary_button = css({height: "2rem", backgroundColor: "#014E86", color: "white"});

    const table_style = css({
        overflowY: "scroll",
        overflowX: "scroll",
        maxHeight: "70vh",
        width: "100%",
        height: "22rem",

        "& tr": {
            "&:hover": {
                background: "#dddd"
            }
        },
        "& td": {
            // padding:rhythm(0.1),
            textAlign: "left",
            borderTop: "1px dashed #ddd",
            borderBottom: "1px dashed #ddd",
            borderLeft: "1px dashed #ddd",
            borderRight: "1px dashed #ddd",
            paddingLeft: "5px",
            paddingRight: "5px",
            fontSize: "0.8rem !important",
            color: "#0152aa",
            wordWrap: "normal"
        },
        "& th": {
            border: "1px solid #ddd0d0",
            fontSize: " 0.7rem",
            color: "#0152aa"
        }
    });

    const modal_dialog = css({
        fontSize: "0.85rem",
        height: "25rem",
        "& select": {
            width: "9rem",
            border: "1px solid #1867ab",
            height: "28px",
            borderRadius: "6px",
            marginRight: "6px"
        },
        "& label": {
            paddingLeft: "15px",
            paddingRight: "10px"
        },
        "& input": {
            maxWidth: "13rem",
            marginLeft: "1rem",
            marginRight: "4rem",
            border: "1px solid #1867ab",
            height: "28px"
        },
        "& hr": {
            border: " 0.1px solid #e8e6e6",
            width: " 100%",
            marginTop: "-0.2rem"
        },
        ".form-check-input": {
            marginTop: "2rem !important"
        },
        ".form-check-label": {
            marginTop: "2.2rem !important",
            marginLeft: "2rem"
        }
    });
    return (
        <>
            <DataContext>
                <div {...style}>
                    
                    <Row style={{marginTop:"10px"}}>
                        <Col xs>
                            <ValueChainsChart /> 
                        </Col>
                        <Col xs>
                            <FinanceStreamChart/>
                        </Col>
                        <Col xs>
                            <SelectCountyChart/>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <Row around="xs" {...chart_widget_style}
                                style={
                                    {
                                        backgroundColor: "white",
                                        marginTop: "1rem"
                                    }
                            }>
                                <div style={
                                    {textAlign: "center"}
                                }>
                                    <div style={
                                        {
                                            display: "flex",
                                            marginTop: "-1rem",
                                            width: "26rem"
                                        }
                                    }>
                                        <Col md={12}>
                                            <Row>
                                                <div {...text_widgets}>
                                                    <div className="rectangle"
                                                        style={
                                                            {width: "201px"}
                                                    }>
                                                        <p>Amount Disbursed as of February 2021
                                                        </p>
                                                    </div>
                                                    <div className="triangle-right "></div>
                                                    <div {...text_widgets_vlaue}>

                                                        <strong>116,588,028 USD</strong> 
                                                    </div>
                                                </div>
                                            </Row>
                                            <Row>
                                                <div style={
                                                    {display: "flex"}
                                                }>
                                                    <div {...text_widgets}>
                                                        <div className="rectangle"
                                                            style={
                                                                {width: "201px"}
                                                        }>
                                                            <p>Number of Investments Opportunities Closed</p>
                                                        </div>
                                                        <div className="triangle-right "></div>
                                                        <div {...text_widgets_vlaue}>
                                                            <strong>73,285</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                            <Row>
                                                <div {...text_widgets}>
                                                    <div className="rectangle"
                                                        style={
                                                            {width: "201px"}
                                                    }>
                                                        <p>Number of Investments Opportunities Open</p>
                                                    </div>
                                                    <div className="triangle-right "></div>
                                                    <div {...text_widgets_vlaue}>
                                                        <strong> {" "}
                                                            <DataCountChart/>
                                                        </strong>
                                                    </div>
                                                </div>
                                            </Row>
                                            {/* <ProjectCurrentStatus /> */} </Col>
                                    </div>
                                </div>
                            </Row>
                            <Row around="xs" {...chart_widget_style} className="showTip" title="Drag to Select Range">
                                <div className="hide">Select Range</div>
                                <div style={
                                    {width: "26rem"}
                                }>
                                    <DealSizeChart/>
                                </div>
                                <div style={
                                    {width: "26rem"}
                                }>
                                    <DealCatSizeChart/>
                                </div>
                            </Row>
                            <Row around="xs" {...chart_widget_style}>
                                <div>

                                    <SizeOfRecipientFirms/>
                                </div>
                            </Row>
                        </Col>
                        <Col md={3}
                            {...chart_widget_style}>
                            <Row>
                                <MapChart/>
                            </Row>
                            <Row style={  {width: "100%"} }>
                                <Col md={12}>
                                    <Button id="download" style={{width: "15rem",fontSize: "0.7rem",marginLeft:"20px"}} onClick={handleShow}
                                        variant="primary">SUBMIT INTEREST ON OPEN INVESTMENT OPPORTUNITIIES</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={5}>
                            <Row around="xs" {...chart_widget_style}
                                // style={{ paddingLeft: "28px" }}
                            >
                                <Col md={7}>
                                    <div style={
                                        {marginLeft: "-1rem"}
                                    }>
                                        <AgeOfRecipient/>
                                    </div>
                                </Col>
                                <Col md={5}
                                    style={
                                        {borderLeft: "2px solid white"}
                                }>
                                    <GenderFinanceChart/>
                                </Col>
                            </Row>
                            <Row {...chart_widget_style}>
                                <Col {...table_style} className="dc-data-table"
                                    md={12}>
                                    {" "}
                                    <Desc/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <Modal {...modal_dialog}
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Header>
                        <Modal.Title>Data Request Form</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="mb-3">
                            <Form.Group as={Col}
                                controlId="formGridEmail">
                                <Form.Label>Select Datasets</Form.Label>
                            </Form.Group>
                            <hr/>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col}
                                controlId="formGridState">
                                <Form.Label>Value Chain</Form.Label>
                                <Form.Control type="email" placeholder="Select  Data"
                                    value={
                                        
                                        window.IVALUECHAINS
                                    }
                                    readOnly/>
                            </Form.Group>

                            <Form.Group as={Col}
                                controlId="formGridState">
                                <Form.Label>Location</Form.Label>
                                <Form.Control type="email" placeholder="Select data"
                                    value={
                                        window.ADMINLEVEL
                                    }
                                    readOnly/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col}
                                controlId="formGridState">
                                <Form.Label>Finance Stream</Form.Label>
                                <Form.Control type="email" placeholder="Select data"
                                    value={
                                        window.IFINANCESTREAM 
                                    }
                                    readOnly/>
                            </Form.Group>
                            <Form.Group className="mb-3" id="formGridCheckbox">
                                <Form.Label style={
                                    {
                                        marginLeft: "2rem",
                                        marginTop: "2.3rem"
                                    }
                                }>
                                    Confirm Selection
                                </Form.Label>
                                <Form.Check type="checkbox"
                                    style={
                                        {marginTop: "-2.3rem"}
                                    }
                                    onClick={handleClick}
                                    checked={checked}/>
                            </Form.Group>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="button-3-datarequest" variant="outline-primary"
                            onClick={handleClose}>
                            Close
                        </Button>
                        <Button id="investment" className="button-3-datarequest" variant="outline-success"
                            disabled={
                                !checked
                            }
                            onClick={handleClose}>
                            Send Request
                        </Button>
                    </Modal.Footer>
                </Modal>
            </DataContext>
        </>
    );
};
